import React from 'react'

import { i18n } from '@localization'
import { useAgentDetailsWF } from '@zet/customer/src/api/hooks/webFlow'
import { Stack } from '@zet/design-system/layout'
import { SH1 } from '@zet/design-system/typography'
import Shield from '@zet/svg/shield'

import ScreenViewEventWrapper from '../../components/screenViewEventWrapper'

const ThankYouAfterVerify = () => {
  const { data } = useAgentDetailsWF()
  return (
    <ScreenViewEventWrapper screenName="thank_you_after_verify">
      <Stack>
        <Shield className=" mt-20 self-center" />
        <Stack className=" ml-3 self-center">
          <SH1 className="text-center">
            {i18n.t('webFlow.thankYouAfterVerify.thankYou')}
          </SH1>
          <SH1 className="text-center">
            {data?.advisorName}{' '}
            {i18n.t('webFlow.thankYouAfterVerify.willShare')}
          </SH1>
        </Stack>
      </Stack>
    </ScreenViewEventWrapper>
  )
}

export default ThankYouAfterVerify
